<template>
  <LayoutActionCard
    :title="title"
    :subtitle="subtitle"
    :is-configured="isConfigured"
    :is-configure-active="isConfigureActive"
    :selected="selected"
    @delete="$emit('delete')"
    @configure="handleConfigure"
  >
    <template #icon>
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7 18C5.9 18 5.01 18.9 5.01 20C5.01 21.1 5.9 22 7 22C8.1 22 9 21.1 9 20C9 18.9 8.1 18 7 18ZM1 2V4H3L6.6 11.59L5.25 14.04C5.09 14.32 5 14.65 5 15C5 16.1 5.9 17 7 17H19V15H7.42C7.28 15 7.17 14.89 7.17 14.75L7.2 14.63L8.1 13H15.55C16.3 13 16.96 12.59 17.3 11.97L20.88 5.48C20.96 5.34 21 5.17 21 5C21 4.45 20.55 4 20 4H5.21L4.27 2H1ZM17 18C15.9 18 15.01 18.9 15.01 20C15.01 21.1 15.9 22 17 22C18.1 22 19 21.1 19 20C19 18.9 18.1 18 17 18Z" fill="#FFFFFF"/>
      </svg>
    </template>

    <template #content>
      <!-- Not Configured State -->
      <div v-if="!isConfigured" class="action-content">
        <!-- Open Product Menu Button -->
        <!-- <button class="open-product-menu-btn" :disabled="!selected" @click="handleOpenProductMenu">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M20 6H12L10 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V8C22 6.9 21.1 6 20 6ZM20 18H4V8H20V18ZM8 13.01L10.5 15.51L14.01 12L18 16H6L8 13.01Z" fill="white"/>
          </svg>
          <span>Open Product Menu</span>
        </button> -->
              </div>

      <!-- Configured State -->
      <div v-else class="action-content action-content--configured">
        <!-- Order Items Table -->
        <div class="order-table">
          <div class="order-table-header">
            <div class="order-table-cell order-table-cell--items">
              <span class="order-table-label">Items:</span>
            </div>
            <div class="order-table-cell order-table-cell--count">
              <span class="order-table-label">Count</span>
            </div>
            <div class="order-table-cell order-table-cell--price">
              <span class="order-table-label">Price</span>
            </div>
          </div>
          <div class="order-table-body">
            <div
              v-for="(item, index) in displayItems"
              :key="index"
              class="order-table-row"
            >
              <div class="order-table-cell order-table-cell--items">
                <span class="order-item-name">{{ item.name }}</span>
              </div>
              <div class="order-table-cell order-table-cell--count">
                <span class="order-item-count">x {{ item.count }}</span>
              </div>
              <div class="order-table-cell order-table-cell--price">
                <span class="order-item-price">$ {{ item.price }}</span>
              </div>
            </div>
          </div>
        </div>
              </div>
    </template>
  </LayoutActionCard>
</template>

<script>
import LayoutActionCard from './LayoutActionCard.vue';

export default {
  name: 'PlaceOrder',
  components: {
    LayoutActionCard
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    selected: {
      type: Boolean,
      default: false
    }
  },
  emits: ['delete', 'configure', 'openProductMenu'],
  data() {
    return {
      localFormData: {
        items: this.data.items || []
      }
    };
  },
  computed: {
    title() {
      return 'Place Order';
    },
    subtitle() {
      return 'Create an order of selected product for the patient';
    },
    // Use savedData for display when available
    displayData() {
      return (this.data && this.data.savedData) ? this.data.savedData : this.data;
    },
    isConfigured() {
      return Boolean(this.displayData && (this.displayData.configured || this.displayData.payload?.line_items?.length > 0));
    },
    isConfigureActive() {
      // Configure is active when items are selected
      return Boolean(this.localFormData.items && this.localFormData.items.length > 0);
    },
    displayItems() {
      // Check if we have payload wrapper with line_items
      const payload = this.displayData?.payload;
      if (payload && payload.line_items && payload.line_items.length > 0) {
        // Convert line_items to display format
        const items = payload.line_items.map(item => ({
          name: item.item_name,
          count: 1,
          price: (item.total || 0).toFixed(2)
        }));
        
        // Add fees as items
        const feeItems = (payload.fees || []).map(fee => ({
          name: fee.notes || fee.type,
          count: 1,
          price: (fee.amount || 0).toFixed(2)
        }));
        
        return [...items, ...feeItems];
      }
      
      // Fallback to legacy items format
      if (this.displayData && this.displayData.items && this.displayData.items.length > 0) {
        return this.displayData.items;
      }
      return [];
    }
  },
  watch: {
    'data.items': {
      handler(newVal) {
        if (newVal && JSON.stringify(newVal) !== JSON.stringify(this.localFormData.items)) {
          this.localFormData.items = newVal || [];
        }
      }
    }
  },
  mounted() {
    // Initialize local form data from props if available
    if (this.data && this.data.items) {
      this.localFormData.items = this.data.items;
    }
  },
  methods: {
    handleOpenProductMenu() {
      this.$emit('openProductMenu');
    },
    handleConfigure() {
      this.$emit('configure');
    }
  }
};
</script>

<style scoped>
.action-content {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
}

/* Open Product Menu Button */
.open-product-menu-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  width: 100%;
  height: 32px;
  padding: 4px 8px;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0.1px;
  color: #FFFFFF;
  background: #81B0E1;
  border: none;
  border-radius: 4px;
  box-shadow: 0px 1px 3px 0px rgba(74, 74, 74, 0.25);
  cursor: pointer;
  transition: background 0.2s;
}

.open-product-menu-btn:hover:not(:disabled) {
  background: #6A9DD4;
}

.open-product-menu-btn:disabled {
  background: #c4c4c4;
  cursor: not-allowed;
}

.open-product-menu-btn:active {
  background: #5A8DC4;
}

/* Order Table */
.order-table {
  display: flex;
  flex-direction: column;
  width: 100%;
  border-top: 1px dashed #C4C4C4;
  padding-top: 8px;
}

.order-table-header {
  display: flex;
  align-items: center;
  gap: 6px;
  width: 100%;
  margin-bottom: 9px;
}

.order-table-body {
  display: flex;
  flex-direction: column;
  gap: 9px;
  width: 100%;
}

.order-table-row {
  display: flex;
  align-items: center;
  gap: 6px;
  width: 100%;
}

.order-table-cell {
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #333;
}

.order-table-cell--items {
  flex: 1;
  min-width: 0;
}

.order-table-cell--count {
  flex: 0 0 auto;
  text-align: center;
  min-width: 50px;
}

.order-table-cell--price {
  flex: 0 0 auto;
  text-align: center;
  min-width: 80px;
}

.order-table-label {
  font-weight: 500;
  letter-spacing: 0.1px;
  color: #333;
}

.order-item-name {
  font-weight: 400;
  color: #333;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
}

.order-item-count {
  font-weight: 400;
  color: #333;
}

.order-item-price {
  font-weight: 400;
  color: #333;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
}

</style>
